const MODAL_ID = 'modal-portal-root';

export { MODAL_ID as default };
